import * as React from "react";
import { SyncStatus } from "./Interfaces";
import { PersonExtended, TicketExtended } from "./TypeExtensions";

export interface GlobalContextValue {
    loggedInUser: PersonExtended;
    proxyUser: PersonExtended | undefined;
    selectedTicketId: number;
    syncStatus: SyncStatus;
    isDeletingTicket: boolean;
    isConfirmingSignaturePending: boolean;
    openPage: string;
    viewMonth: string;
    shouldPushTickets: boolean;
    shouldSync: boolean;

    setSelectedTicketId(ticketId: number): void;

    setViewMonth(viewMonth: string): void;

    setOpenPage(page: string): void;

    setShowLoadingTicketsDialogue(shouldShow: boolean): void;

    setShowProxyPilotDialogue(shouldShow: boolean, pilotToProxy?: PersonExtended | undefined): void;

    setShowAddTicketDialogue(shouldShow: boolean, ticketToClone?: TicketExtended | undefined): void;

    cloneTicket(ticketToClone: TicketExtended): void;

    toggleDemoMode(context: GlobalContextValue, isSuperUser: boolean): void;

    showUserPreferences(shouldShow: boolean): void;

    setLoggedInUser(user: PersonExtended | undefined): void;

    deleteSelectedTicket(): void;

    displaySignaturePendingDialogue(): void;

    setShouldPushTickets(shouldPush: boolean): void;

    setShouldSync(shouldSync: boolean): void;

    showForceReloadDialogue(): void;

    showReleaseNotes(shouldShow: boolean): void;
}

// I had to move the context declaration here to fix an initialization error that only started after I made the CardMenuPage a class, whee
// seems like it was a webpack issue, above my pay grade but here is the stackoverflow post that helped me figure out what was breaking fwiw
// https://stackoverflow.com/questions/56384761/cannot-access-class-contexttype-within-a-child-component

// TODO - need to type the context, not getting any type checking in the function components
export const GlobalContext = React.createContext<GlobalContextValue>({} as GlobalContextValue);
